module.exports = __webpack_public_path__ + "static/media/rupee-indian.cb75c8a7.svg";